import options from './options';

const { name } = options;

export const curGeneralProtocol = state => state.models[name].protocolItem;
export const curFedPoints = state => state.models[name].fedPoints;
export const curAgroPoints = state => state.models[name].agroPoints;